<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
    
    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="7" />
      <div class="box5" style="position: relative;min-height: 950px;">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">我的反馈</div>
        </div>
        <div class="box7"></div>
        <div style="overflow: hidden; margin-top: 2%;">
          <a-input-search v-model="search" placeholder="请输入手机号" style="width: 200px; float: left;" @search="onSearch" />
          <router-link to="/add_feedback"><div class="box14">+提交反馈</div></router-link>
        </div>
        <div class="box12">

          <div class="box13">手机号</div>
          <div class="box13">反馈内容</div>
          <div class="box13">反馈类型</div>
          <div class="box13">更新时间</div>
          <div class="box13">处理状态</div>
          <div class="box13" style="color: #666666;">操作</div>
        </div> 
        
        <div v-if="list.length > 0">
          <div :key="index" v-for="(item,index) in list" class="box12" style="margin-top: 0; background: none; border-bottom: 1px solid #EEEEEE;">
            <div class="box13">{{item.userNum}}</div>
            <div class="box13" v-html="item.complaint" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"></div>
            <div class="box13">{{item.types}}</div>
            <div class="box13">{{item.updatedAt}}</div>
            <div class="box13">{{item.fettle}}</div>
            <router-link :to="'/complaint_details?uuid=' + item.uuid"><div class="box13" style="color: #2B9A34;cursor: pointer;">详情</div></router-link>
            
  
          </div>
        </div>

        <div v-else style="text-align: center; font-size: 14px; margin-top: 40px;">
          没有数据~
        </div>

        
<div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
      <!-- <div style="width: 100%; height: 100px;"></div> -->
        <a-pagination
          show-quick-jumper
          :default-current="1"
          :total="totalPages*10"
          @change="fanye"
        />
      </div>

      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";

export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {
              totalPages: 1,//总页数
              list: [], //消息数据
              page: 0, //页码
              search: '', //搜索文字
            }
        },
        created() {
          this.getList()
        },
        methods: {
          // 搜索
          onSearch(e) {
            this.search = e
            this.getList()
          },
          // 翻页
          fanye(e) {
            this.page = e - 1
            this.getList()
          },
          // 获取列表
          getList() {
            this.api.message_list({ search: this.search, page: this.page, size: 7 })
              .then(res => {
                if(res.ok) {
                  this.list = [...res.data.content]
                  this.totalPages = res.data.totalPages
                }
              })
          },
        },
    };
</script>
 <style>
.box13 >p {
  overflow:hidden;white-space:nowrap;text-overflow:ellipsis;
}
</style>
<style scoped>
  .shangyiye {
  width: 100px;
  height: 32px;
  border: 1px solid #EDE9E9;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  float: left;
  cursor: pointer;
}
  .ant-input-affix-wrapper {
    border: 1px solid #EDE9E9;
    border-radius: 5px;
    outline: none;
  }
.box14 {
  width: 120px;
height: 32px;
border: 1px solid #2C9A34;
float: right;
text-align: center;
line-height: 32px;

font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #2C9A34;


}
  .box13 {
    width: 16.6666%;
    height: 100%;
    float: left;

font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #333333;
line-height: 60px;
text-align: center;
overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .box12 {
    width: 100%;
height: 60px;
line-height: 60px;
background: #F4F4F4;
margin-top: 4%;

  }
    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }
    
    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }
    
    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }
    
    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }
    
    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }
    
    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }
    
.box5 {
        min-height: 1023px;
        width: 80%;
        /* min-height: 1023px; */
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }
    
    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }
    
    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }
    
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }
    
    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>


// WEBPACK FOOTER //
// src/components/my_feedback.vue